exports.detectUa = function () {
    let browers = {};
    let ua = navigator.userAgent.toLowerCase();
    browers.iPad = ua.match(/ipad/);
    browers.iPhone = ua.match(/iphone/);
    browers.isAndroid = ua.match(/android/);
    browers.isiOS = ua.match(/ipad|iphone|ios/);
    browers.isDesktop = !browers.isiOS && !browers.isAndroid;
    browers.ie = ua.match(/iemobile/);
    browers.isWifi = ua.match(/nettype\/wifi|technology\/wifi/);
    browers.force_ssl = ua.match(/Android (5|6)/i);
    browers.is_ios_6 = ua.match(/iOS 6/i);
    browers.is_liveapp = ua.match(/LiveApp/i);
    return browers;
};

// function checkOpen(scheme) {
//      var iframe = document.createElement( "iframe" ),
//      num = 0,
//      timer;
//      iframe.src = scheme;
//      iframe.style.display = "none";
//      document.body.appendChild( iframe );
//      timer = setInterval( function() {
//        num++;
//      }, 20 );
//      setTimeout( function() {
//        clearInterval( timer );
//        document.body.removeChild( iframe );
//        if ( num > 50 ) {
//          location.href = "https://static.dongqiudi.com/app/apk/dongqiudi_website.apk";
//        }
//      }, 2000 );
//  }
exports.jumpUrl = function (is_apk) {
    ga('send', 'event', 'app', 'download', location.pathname, 1);
    let isiOS = navigator.userAgent.match('iPad') || navigator.userAgent.match('iPhone') || navigator.userAgent.match('iPod'),
        isAndroid = navigator.userAgent.match('Android'),
        isDesktop = !isiOS && !isAndroid;
    function getCookie (name) { // 获取cookie方法
        var arr, reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        if (arr = document.cookie.match(reg)) { return unescape(arr[2]); } else { return null; }
    }
    function jumpDownload (android_url, ios_url) { // 跳转下载方法
        if (isAndroid) {
            location.href = android_url;
        } else if (isiOS) {
            location.href = ios_url;
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }
    // 没弹窗用户下载方法
    function jumpDownloadCom (android_url, ios_url) { // 跳转下载方法
        if (isAndroid) {
            // let apk = "http://allfootball-static.dongqiudi.com/n/static/img/google-release-2.1.3_m_banner.apk";
            let apk = location.href = '/download';
            let google_play = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
            adroidDownload(apk, google_play);
        } else if (isiOS) {
            location.href = 'https://go.onelink.me/app/ff33e3d5';
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }
    // 有弹窗用户下载方法（新）
    function jumpDownloadPopup () {
        if (isAndroid) {
            return '/download';
        } else if (isiOS) {
            return 'https://go.onelink.me/1751978436?pid=M_FB';
        } else if (isDesktop) {
            return 'http://www.allfootballapp.com/home';
        }
    }
    // android随机跳转apk或gp
    function adroidDownload (apk, google_play) {
        console.log('随机方法');
        if (Math.random() >= 0.5) {
            location.href = apk;
        } else {
            location.href = google_play;
        }
    }
    goog_snippet_vars = function () {
        var w = window;
        w.google_conversion_id = 838643918;
        w.google_conversion_label = 'ds1fCN_xrHkQzuHyjwM';
        w.google_remarketing_only = false;
    };
    // 请勿更改以下代码。
    function goog_report_conversion (url) {
        // 判断是否是operamini浏览器，如果是则直接下载
        let isOperaMini = navigator.userAgent.indexOf('Opera Mini');
        console.log('isOperaMini', isOperaMini);
        goog_snippet_vars();
        window.google_conversion_format = '3';
        var opt = new Object();
        opt.onload_callback = function () {
            if (typeof (url) !== 'undefined') {
                console.log('url2', url);
                if (isAndroid) {
                    // 先尝试跳转GP
                    window.location = 'market://details?id=com.allfootball.news';
                    setTimeout(() => {
                        console.log('跳转GP失败');
                        window.location = url;
                    }, 1000);
                    return;
                }
                window.location = url;
            }
        };
        var conv_handler = window['google_trackConversion'];
        if (typeof (conv_handler) === 'function') {
            if (isOperaMini >= 0) {
                console.log('url', url);
                window.location = url;
            } else {
                conv_handler(opt);
            }
        }
    }
    var utm_source = getCookie('utm_source');// 浏览器
    var utm_campaign = getCookie('utm_campaign');// 二级标签
    var search = (location.search || '').slice(1);
    if (utm_source === 'google_search' && utm_campaign === 'EPL') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'La Liga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Bundesliga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Serie A') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Transfers') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'UC-Browser' && utm_campaign === 'p20') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (location.pathname === '/downloadCoin' || search.indexOf('utm_source=shareForAFCoin') > -1 || utm_source === 'shareForAFCoin') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else {
        if (is_apk) { // android下载
            if (location.hostname === 'm.all.football') {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-402.apk');
            } else {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-402.apk');
            }
        } else { // ios下载
            let url = jumpDownloadPopup();
            console.log('ios的url', url);
            location.href = url;
            goog_report_conversion(url);
        }
    }
};

exports.lazyload = function (id, classImg) {
    let listwrap = document.getElementById(id);
    if (listwrap) {
        let teamLogo = document.getElementsByClassName(classImg);
        var windowH = window.innerHeight;
        var offsetY = window.pageYOffset;
        for (var i = 0; i < teamLogo.length; i++) {
            var iT = teamLogo[i].getBoundingClientRect().top;
            if (iT < (windowH + offsetY + windowH * 3 / 4)) {
                if (teamLogo[i].getAttribute('data-src')) {
                    teamLogo[i].src = teamLogo[i].getAttribute('data-src');
                    teamLogo[i].removeAttribute('data-src');
                }
            }
        }
    }
};

exports.timeForInOut = function () {
    // let saStartTime = new Date();
    // window.onbeforeunload = function(){
    //     let beforeLeave = new Date();
    //     let duration = (beforeLeave.getTime() - saStartTime.getTime()) / 1000;
    //     sa.track('index_leave', {
    //       pageUrl: location.href,
    //       pageStayTime: duration,
    //       pagePosition: (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop
    //     });
    // }
};
// 检测opera mini是否支持scroll事件（判断是否是opear mini的极致模式）
exports.checkOperamini = () => {
    let isOperaMini = (navigator.userAgent.indexOf('Opera Mini') > -1);
    return isOperaMini;
};

exports.record = (url) => { // 接入打点
    const prefix = '//stat.allfootballapp.com';
    let newImage = new Image();
    newImage.src = `${prefix}/${url}`;
    return newImage;
};

exports.getQueryString = (name) => { // 获取url参数
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
};



// WEBPACK FOOTER //
// ./src/util/util.js